module.exports = __webpack_public_path__ + "img/oota.2284617b.jpg";